import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CategoryForm from "../components/CategoryForm";

import { useCategories } from "../hooks/useCategories";

const CreateCategoryPage = () => {
  const navigate = useNavigate();

  const {
    createCategory
  } = useCategories({
    activeOnly: false
  });

  const [saving, setSaving] =
    useState(false);

  const [serverError, setServerError] =
    useState("");


  const handleSubmit =
    async (data) => {
      try {
        setSaving(true);
        setServerError("");

        const created =
          await createCategory(data);

        navigate(
          `/categories/${created.id}`,
          { replace: true }
        );
      } catch (error) {
        setServerError(
          error?.response?.data
            ?.message ||
          "Unable to create category."
        );

        throw error;
      } finally {
        setSaving(false);
      }
    };


  return (
    <div className="max-w-4xl space-y-6">
      <div>
        <button
          type="button"
          onClick={() =>
            navigate("/categories")
          }
          className="mb-3 text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          ← Back to categories
        </button>

        <h1 className="text-2xl font-bold text-slate-900">
          Create category
        </h1>

        <p className="mt-1 text-sm text-slate-500">
          Add a new category for your offerings.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6 sm:p-8">
        <CategoryForm
          mode="create"
          onSubmit={handleSubmit}
          onCancel={() =>
            navigate("/categories")
          }
          loading={saving}
          serverError={serverError}
        />
      </div>
    </div>
  );
};

export default CreateCategoryPage;